import { Box, Button, Grid, Typography } from "@mui/material";
import { MbTextField } from "../../../../../components/MbTextFields";
import { useUser } from "../../../../../contexts/user.context";
import { useForm } from "react-hook-form";
import { mobilizeiStoresService } from "../../../../../services/mobilizei/stores.service";
import _ from "lodash";
import useAppInfo from "../../../../../hooks/appInfo.hook";
import { storeStatus } from '../../../../../utils/constants';

export default function DunsContent({ blocked }) {
  const { user, setUser } = useUser();
  const { appInfo } = useAppInfo();

  const isDisabled = (appInfo?.storeStatus !== storeStatus.ACTIVE) || blocked;

  const { getValues, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      dunsNumber: user?.store?.dunsNumber
    }
  });

  function onSubmit() {
    let data = getValues();

    if (data.dunsNumber) {
      data.dunsNumber = data.dunsNumber.trim()
    }

    mobilizeiStoresService
      .updateStoreById(user?.store?.platformId, user?.store?.id, {
        dunsNumber: data.dunsNumber
      }).catch(() => null)

    // Set the local user properties
    setUser({
      ...user,
      store: {
        ...user?.store,
        dunsNumber: data.dunsNumber
      }
    })
  }

  return (
    <Box>
      {user?.store?.dunsNumber
        ? (
          <Typography variant="body1">
            Seu número DUNS: <strong style={{ color: '#3cd568' }}>{user?.store?.dunsNumber}</strong>
          </Typography>
        )
        : (
          <Grid
            container
            component="form"
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid item>
              <Typography variant="body1" mb={2}>
                Para criar uma conta de desenvolvedor organizacional no Google ou na Apple, <strong>o primeiro passo é obter um número DUNS</strong>.
              </Typography>

              <Typography variant="body1" mb={2}>
                Esse número é único e funciona como um "CNPJ internacional". Ele é exigido tanto pelo Google quanto pela Apple para validar a existência da sua empresa.
              </Typography>

              <Typography variant="body1" mb={2}>
                A boa notícia é que o DUNS é gratuito e pode ser solicitado de duas formas:
              </Typography>
              <Typography variant="body1" mb={2} ml={2}>
                <strong>• Diretamente pela D&B</strong>, empresa responsável pela emissão — prazo de até 30 dias úteis;
              </Typography>
              <Typography variant="body1" mb={2} ml={2}>
                <strong>• Pelo site da Apple</strong>, com um prazo bem mais rápido — até 3 dias úteis.
              </Typography>

              <Typography variant="body1">
                <a
                  href="https://mobilizei.com.br/tutoriais/como-obter-um-numero-duns"
                  target="_blank">Clique aqui </a>
                para conferir o passo a passo.
              </Typography>
            </Grid>

            <Grid item>
              <MbTextField
                error={errors.dunsNumber?.message}
                label="Já tem o seu número DUNS? Agora é só incluí-lo no campo abaixo:"
                inputProps={{
                  placeholder: "Digite o número DUNS da sua empresa",
                  disabled: isDisabled
                }}
                register={register('dunsNumber', {
                  required: "Insira o número DUNS para continuar."
                })}
              />

              <Box display='flex' justifyContent='center' marginTop={4} width='100%'>
                <Button variant="contained" disabled={isDisabled} type="submit">
                  próximo passo
                </Button>
              </Box>
            </Grid>
          </Grid>
        )}
    </Box>
  )
}